import { HttpClient, JsonpClientBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JobInterface } from '@contracts/interfaces/job.interface';
import { ConnectionService } from './connection.service';
import { JobProgressDialogComponent } from '../dialogs/job-progress/job-progress.component';
import { MatDialog } from '@angular/material/dialog';


@Injectable({
  providedIn: 'root'
})
export class JobService {
 
  constructor(private http: HttpClient,
    private connectionService: ConnectionService,
    private dialog: MatDialog
    ) {}
 
  find(query: any = {}) {
    return this.http.post(this.connectionService.address + "/job-service/find", { query });
  }

  create(job: JobInterface) {
    return this.http.post(this.connectionService.address + "/job-service/create", { job });
  }

  delete(job: JobInterface) {
    return this.http.post(this.connectionService.address + "/job-service/delete", { job });
  }

  follow(jobID: string) {
    return this.http.post(this.connectionService.address + "/job-service/follow", { jobID });
  }

  onCompleted(jobID: string) {

  }

  showProgress(jobID: string, callback: any) {
    let dialog = this.dialog.open(JobProgressDialogComponent, {
        width: '200px',
        data: {
          jobID
        }
    });
    
    dialog.disableClose = true;

    dialog.afterClosed().subscribe(r => {
        callback(r);
    });
  }
}
